/**
 * @file paddlejs banner
 * @author wanzhongyun
 */

import React from 'react';
import { IPaddleJsBanner } from './../../type';

import './style.less';


const PaddleJSBanner: React.FC<IPaddleJsBanner> = props => {
    const { title, desc, btnWord, btnLink } = props;
    return (
        <div className='paddle-js-banner-wrapper'>
            <div className='paddle-js-banner-title'>{title}</div>
            <div className='paddle-js-banner-desc'>{desc}</div>
            <a href={btnLink} target='_blank' rel='noreferrer'>
                <span className='paddle-js-banner-link'>{btnWord}</span>
            </a>
        </div>
    );
};

export default PaddleJSBanner;